import type { SupportedLanguage } from '../redux/languageSlice';

/** The shape any card needs to pick a title — deliberately narrower than Recipe. */
export interface TranslatableTitle {
  title: string;
  translatedTitles?: { en?: string; fr?: string };
}

/**
 * The recipe title to display in the current app language.
 *
 * Recipes are scraped in their source language and translated in the
 * background (`recipeTranslationService`), so `translatedTitles` fills in over
 * time and is routinely absent — falling back to the original title is the
 * normal path, not an error case.
 */
export function resolveRecipeTitle(
  recipe: TranslatableTitle,
  language: SupportedLanguage | string
): string {
  const translated = recipe.translatedTitles?.[language as 'en' | 'fr'];
  return translated?.trim() ? translated : recipe.title;
}
